import { render, staticRenderFns } from "./stuRegSta.vue?vue&type=template&id=36df86d6&scoped=true"
import script from "./stuRegSta.vue?vue&type=script&lang=js"
export * from "./stuRegSta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df86d6",
  null
  
)

export default component.exports